const TransactionSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_CUSTOMER",
                "tableName": "",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "TransactionDateFrom",
                "tableName": "",
                "label": "Trans. Date From",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "R_CARRIER",
                "tableName": "",
                "label": "Carrier:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "TransactionDateTo",
                "tableName": "",
                "label": "Transaction Date To",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CarrierName",
                "tableName": "",
                "label": "Carrier Name:",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "DeliveryDateFrom",
                "tableName": "",
                "label": "Delivery Date From",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "",
                "label": "Transaction #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "DeliveryDateTo",
                "tableName": "",
                "label": "Delivery Date To",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    }
];
export default TransactionSearchFormLayout;